export type RequestObservationOutcome =
	| 'success'
	| 'httpError'
	| 'graphqlError'
	| 'networkError'
	| 'abort';

export type RequestObservation =
	| {
			kind: 'http';
			method: string;
			route: string;
			durationMs: number;
			outcome: RequestObservationOutcome;
			status?: number;
	  }
	| {
			kind: 'graphql';
			method: 'POST';
			operation?: string;
			durationMs: number;
			outcome: RequestObservationOutcome;
			status?: number;
	  };

type RequestObservationListener = (observation: RequestObservation) => void;

const listeners = new Set<RequestObservationListener>();
const UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;

export const requestObservationNow = (): number => {
	if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
		return performance.now();
	}
	return Date.now();
};

export const requestObservationDuration = (startedAt: number): number =>
	Math.max(0, Math.round(requestObservationNow() - startedAt));

export const normalizeRequestRoute = (path: string): string => {
	try {
		const parsed = new URL(path, 'https://conversation-assistant.invalid');
		return parsed.pathname
			.replace(UUID_SEGMENT_PATTERN, '{id}')
			.replace(NUMERIC_SEGMENT_PATTERN, '/{id}');
	} catch {
		return '/unparseable';
	}
};

export const subscribeToRequestObservations = (
	listener: RequestObservationListener,
): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const hasRequestObservationSubscribers = (): boolean => listeners.size > 0;

export const publishRequestObservation = (observation: RequestObservation): void => {
	for (const listener of Array.from(listeners)) {
		try {
			listener(observation);
		} catch {
			// Observability must never change the request's result or error behavior.
		}
	}
};

export const __resetRequestObserversForTests = (): void => {
	listeners.clear();
};
